/**
 * Reemplaza los placeholders del contrato con los valores del form.
 *
 * Mantiene el mismo mapping que AgreementController::applyPlaceholders
 * en el back, para que lo que el usuario ve en el editor / preview sea
 * idéntico a lo que terminará persistiendo en BD y renderizándose en
 * el PDF.
 *
 * Se usa:
 *  - En el wizard, al cargar una plantilla: reemplaza inmediatamente
 *    así el editor muestra los datos reales en vez de los tokens.
 *  - En el preview de Step4: para que la vista previa coincida con
 *    el contrato final.
 *
 * Si un placeholder no tiene valor en `data`, queda como string vacío
 * en lugar de dejar el token literal — replica el comportamiento del
 * back (`?? ''`).
 */
const applyPlaceholders = (html, data = {}) => {
    if (!html || typeof html !== 'string') return html ?? '';
    const replacements = {
        '[Nombre de la Empresa Compradora]': data.company_name ?? '',
        '[NIT de la empresa compradora]': data.company_document ?? '',
        '[dirección de la empresa compradora]': data.company_address ?? '',
        '[nombre del representante legal]': data.signatory_name ?? '',
        '[cargo del representante legal]': data.signatory_position ?? '',
        '[número de días]': data.days_to_pay ?? '',
        '[Plazo de pago]': data.days_to_pay ?? '',
        '[valor en COP]': data.agreement_amount ?? '',
        '[número de códigos]': data.moves_amount ?? '',
        '[codigos de regalo]': data.gift_moves ?? 0,
        '[Metodo de pago]': data.payment_type_desc ?? '',
        '[Dias de incumplimiento]': data.days_breach ?? '',
        '[Dias de rescision]': data.days_rescission ?? '',
    };
    let result = html;
    Object.entries(replacements).forEach(([k, v]) => {
        result = result.split(k).join(String(v));
    });
    return result;
};

export default applyPlaceholders;
